import { BlenderIcon } from './BlenderIcon';

/**
 * author: Google
 * id AC980D29-7F19-4356-970E-A147CFEB64E3
 * name blender
 * version: 3.3.92
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/blender.svg
 * tags
 * - Food / Drink 
 * - Home Automation 
 */
export const FoodProcessorIcon = BlenderIcon;
export default FoodProcessorIcon